import React from 'react';
import StepBar from '@splunk/react-ui/StepBar';
import { _ } from '@splunk/ui-utils/i18n';

type ExportStepBarProps = Pick<
    React.ComponentProps<typeof StepBar>,
    'activeStepId'
>;

export const ExportStepBar = ({ activeStepId }: ExportStepBarProps) => (
    <StepBar activeStepId={activeStepId}>
        <StepBar.Step>{_('Configuring')}</StepBar.Step>
        <StepBar.Step>{_('Searching')}</StepBar.Step>
        <StepBar.Step>{_('Downloading')}</StepBar.Step>
    </StepBar>
);
